import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { TranslateModule } from "@ngx-translate/core";

import { ProductPageStateModule } from "@hermes/states/product-page";

import { ShadeFinderEffects } from "./effects/shade-finder.effects";
import { ShadeFinderFacade } from "./facades/shade-finder.facade";
import * as fromShadeFinder from "./reducers/shade-finder.reducer";
import { ShadeFinderService } from "./services/shade-finder.service";

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature(
            fromShadeFinder.shadeFinderFeatureKey,
            fromShadeFinder.reducer,
        ),
        EffectsModule.forFeature([ShadeFinderEffects, ShadeFinderService]),
        TranslateModule,
        ProductPageStateModule,
    ],
    providers: [ShadeFinderFacade],
})
export class ShadeFinderStateModule {}
